import { useState } from 'react';
import { Button } from '@/ui/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/ui/components/ui/dialog';
import { AdminLayout } from '../components/AdminLayout';
import { CreateProjectForm } from '../components/dashboard/CreateProjectForm';
import { ProjectList } from '../components/dashboard/ProjectList';
import { useAdminAuth } from '../context/AdminAuthContext';
import { useAdminProjects } from '../hooks/use-admin';

export function AdminDashboardPage() {
	const { data, loading, error } = useAdminProjects();
	const { user, isViewer } = useAdminAuth();
	const [showForm, setShowForm] = useState(false);

	const projects = data?.adminProjects ?? [];

	return (
		<AdminLayout>
			<div className='flex items-center justify-between mb-8'>
				<div>
					<h1 className='text-2xl font-semibold text-foreground tracking-tight'>
						Projects
					</h1>
					<p className='mt-1 text-sm text-muted-foreground'>
						Manage your feedback collection projects
					</p>
				</div>
				{user && !isViewer && (
					<Button onClick={() => setShowForm(true)}>
						New project
					</Button>
				)}
			</div>

			<Dialog open={showForm} onOpenChange={setShowForm}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>Create project</DialogTitle>
					</DialogHeader>
					<CreateProjectForm
						onSuccess={() => setShowForm(false)}
						onCancel={() => setShowForm(false)}
					/>
				</DialogContent>
			</Dialog>

			<ProjectList
				projects={projects}
				loading={loading}
				error={!!error}
				onCreateClick={() => setShowForm(true)}
			/>
		</AdminLayout>
	);
}
